import _extends from "@babel/runtime-corejs3/helpers/extends";
import _toConsumableArray from "@babel/runtime-corejs3/helpers/toConsumableArray";
import _asyncToGenerator from "@babel/runtime-corejs3/helpers/asyncToGenerator";
import _slicedToArray from "@babel/runtime-corejs3/helpers/slicedToArray";
import _regeneratorRuntime from "@babel/runtime-corejs3/regenerator";
import _mapInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/map";
import _Promise from "@babel/runtime-corejs3/core-js-stable/promise";
import _filterInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/filter";
import _includesInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/includes";
import _concatInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/concat";
import React, { useState, useRef } from 'react';
import PropTypes from 'prop-types';
import { Form, Field } from 'react-final-form';
import { Button, Dialog, SelectField } from '@unite-us/ui';
import EditButton from '../../common/EditButton';
import Spinner from '../../common/spinners/Spinner';
import { hooks } from '../../../config/api';
var PreferredLanguagesEdit = function PreferredLanguagesEdit(_ref) {
  var _dataLanguages$data;
  var initialValues = _ref.initialValues,
    updatePreferredLanguages = _ref.updatePreferredLanguages;
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    isSubmitting = _useState2[0],
    setIsSubmitting = _useState2[1];
  var _hooks$useFind = hooks.useFind('languages', {}, {
      api: 'coreApi',
      queryConfig: {
        placeholderData: undefined,
        staleTime: Infinity,
        refetchInterval: false
      },
      sort: 'name'
    }),
    dataLanguages = _hooks$useFind.data,
    isFetching = _hooks$useFind.isFetching;
  var languages = (dataLanguages === null || dataLanguages === void 0 || (_dataLanguages$data = dataLanguages.data) === null || _dataLanguages$data === void 0 ? void 0 : _dataLanguages$data.data) || [];
  var languagesOptions = _mapInstanceProperty(languages).call(languages, function (language) {
    return {
      label: language.name,
      value: language.id
    };
  });
  var preferredLanguagesModalRef = useRef(null);
  var openDialog = function openDialog() {
    preferredLanguagesModalRef.current.openDialog();
  };
  var closeDialog = function closeDialog() {
    preferredLanguagesModalRef.current.closeDialog();
  };
  var onSubmit = /*#__PURE__*/function () {
    var _ref2 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee(formValues, form) {
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            setIsSubmitting(true);
            _context.next = 3;
            return updatePreferredLanguages(formValues);
          case 3:
            setIsSubmitting(false);
            closeDialog();
            form.reset();
          case 6:
          case "end":
            return _context.stop();
        }
      }, _callee);
    }));
    return function onSubmit(_x, _x2) {
      return _ref2.apply(this, arguments);
    };
  }();
  var filterLanguages = function filterLanguages(search, selectedValues) {
    return new _Promise(function (resolve) {
      var regex = new RegExp(search, 'i');
      var filteredOptions = _filterInstanceProperty(languagesOptions).call(languagesOptions, function (language) {
        return regex.test(language.label);
      });
      if (selectedValues.length > 0) {
        var _context2;
        var selectedOptions = _filterInstanceProperty(languagesOptions).call(languagesOptions, function (language) {
          return _includesInstanceProperty(selectedValues).call(selectedValues, language.value) && !filteredOptions.some(function (option) {
            return option.value === language.value;
          });
        });
        filteredOptions = _concatInstanceProperty(_context2 = []).call(_context2, _toConsumableArray(filteredOptions), _toConsumableArray(selectedOptions));
      }
      resolve({
        options: filteredOptions
      });
    });
  };
  return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(EditButton, {
    id: "preferred-languages-edit-btn",
    edit: openDialog,
    labelText: "Edit",
    "aria-label": "Edit preferred languages"
  }), /*#__PURE__*/React.createElement(Form, {
    initialValues: initialValues,
    keepDirtyOnReinitialize: true,
    onSubmit: onSubmit,
    render: function render(_ref3) {
      var handleSubmit = _ref3.handleSubmit,
        submitting = _ref3.submitting;
      return /*#__PURE__*/React.createElement(Dialog, {
        id: "edit-preferred-languages",
        onCloseModal: closeDialog,
        onRequestClose: closeDialog,
        ref: preferredLanguagesModalRef,
        title: "Edit preferred languages",
        type: "form",
        actions: [/*#__PURE__*/React.createElement(Button, {
          id: "edit-preferred-languages-cancel-btn",
          onClick: closeDialog,
          disabled: submitting,
          label: "Cancel"
        }), /*#__PURE__*/React.createElement(Button, {
          id: "edit-preferred-languages-save-btn",
          disabled: submitting,
          label: "Save",
          primary: true,
          onClick: handleSubmit
        })]
      }, /*#__PURE__*/React.createElement("div", {
        className: "h-56"
      }, isSubmitting || isFetching ? /*#__PURE__*/React.createElement(Spinner, null) : /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
        "data-testid": "edit-preferred-spoken-languages"
      }, /*#__PURE__*/React.createElement(Field, {
        name: "preferred_spoken_languages"
      }, function (props) {
        return /*#__PURE__*/React.createElement(SelectField, _extends({
          id: "edit-preferred-spoken-languages",
          label: "Preferred Spoken Languages",
          clearable: true,
          multiple: true,
          options: languagesOptions,
          loadOptions: function loadOptions(search) {
            return filterLanguages(search, props.input.value);
          },
          placeholder: "Select..."
        }, props));
      })), /*#__PURE__*/React.createElement("div", {
        "data-testid": "edit-preferred-written-languages"
      }, /*#__PURE__*/React.createElement(Field, {
        name: "preferred_written_languages"
      }, function (props) {
        return /*#__PURE__*/React.createElement(SelectField, _extends({
          id: "edit-preferred-written-languages",
          label: "Preferred Written Languages",
          clearable: true,
          multiple: true,
          options: languagesOptions,
          loadOptions: function loadOptions(search) {
            return filterLanguages(search, props.input.value);
          },
          placeholder: "Select..."
        }, props));
      })))));
    }
  }));
};
PreferredLanguagesEdit.propTypes = {
  initialValues: PropTypes.object.isRequired,
  updatePreferredLanguages: PropTypes.func.isRequired
};
export default PreferredLanguagesEdit;
//# sourceMappingURL=PreferredLanguagesEdit.js.map